import alarmService from '../service/alarm'
import Vue from 'vue'
const state = {
    alarms: [],
    alarmsLoading: false,
    createLoading: false,
}

const actions = {
    getAlarm({ commit }, {pointId,alarmId}) {
        return alarmService.getAlarm(pointId,alarmId)
    },
    getAlarms({ commit }, pointId) {
        commit('setLoading', true)
        return alarmService.getAlarms(pointId).then(alarms => {
            commit('setAlarms', alarms)
        }).catch((e) => {
            console.log(e)
            commit('setLoading', false)
        })
    },
    createAlarm({ commit }, { pointId, alarm }) {
        commit('setCreateLoading', true)
        return alarmService.createAlarm(pointId, alarm)
            .then(res => {
                return alarmService.getAlarm(pointId, res._id);
            })
            .then(alarm => {
                commit('addAlarm', alarm)
            }).finally(() => {
                commit('setCreateLoading', false)
            })
    },
    updateAlarm({ commit }, { pointId, alarm }) {
        return alarmService.updateAlarm(pointId, alarm)
            .then((res) => {
                return alarmService.getAlarm(pointId,res._id);
            }).then(newAlarm => {
                commit('setAlarm', newAlarm);
            })
            .finally(() => {
                commit('setLoading', false)
            })
    },
    deleteAlarm({ commit }, { pointId, alarmId }) {
        return alarmService.deleteAlarm(pointId, alarmId).then(() => {
            commit('removeAlarm', alarmId)
        }).catch((e) => {
            console.log(e)
            commit('setLoading', false)
        })
    }
}
const mutations = {
    setCreateLoading(state, loading) {
        state.setCreateLoading = loading
    },
    setLoading(state, loading) {
        state.alarmsLoading = loading
    },
    removeAlarm(state, alarmId) {
        const index = state.alarms.findIndex(x => x._id == alarmId)
        if (index != -1) {
            state.alarms.splice(index, 1)
        }
        state.alarmsLoading = false
    },
    setAlarms(state, alarms) {
        state.alarms = alarms;
        state.alarmsLoading = false
    },
    setAlarm(state, alarm) {
        const index = state.alarms.findIndex(x => x._id == alarm._id)
        if (index != -1) {
            Vue.set(state.alarms, index, alarm)
            // state.alarms[index] = alarm
        }
        state.alarmsLoading = false

    },
    addAlarm(state, alarm) {
        state.alarms.push(alarm)
        state.alarmsLoading = false

    },
}
export default {
    namespaced: true,
    state,
    actions,
    mutations
}



